import type { RatingState } from "@esgt/event-store"
import { RatingType, isVsmeMethod } from "@esgt/types"

export type CompanyTextsProgress = {
  aboutCompany: boolean
  companyGoals?: boolean
  companyStrategy?: boolean
}

export function companyTextsProgress(ratingState: RatingState, methodName?: string): CompanyTextsProgress {
  // VSME ratings don't have company texts
  const isVSME = isVsmeMethod(methodName)
  const isFree = ratingState?.ratingType === RatingType.Free

  const status: CompanyTextsProgress = {
    aboutCompany: isVSME || textIsValid(ratingState.companyTexts?.aboutCompany),
  }
  if (!isFree) {
    status.companyGoals = isVSME || textIsValid(ratingState.companyTexts?.companyGoals)
    status.companyStrategy = isVSME || textIsValid(ratingState.companyTexts?.companyStrategy)
  }
  return status
}

export function textIsValid(text?: string) {
  return !!text && typeof text === "string" && text.trim().length > 0
}
